module.exports = __webpack_public_path__ + "static/media/flag.7e038fb2.svg";